import { Link } from "react-router-dom";
import { useLocale } from "../contexts/LocaleContext";
import { useConsent } from "../contexts/ConsentContext";

export function Footer() {
  const { t } = useLocale();
  const { openPreferences } = useConsent();

  return (
    <footer>
      <div className="footer-columns">
        <div className="footer-col footer-brand">
          <Link to="/start" className="logo">
            <img
              src="/static/img/die-welt-in-kunst_logo_V2.png"
              alt={t("footer.logoAlt")}
            />
          </Link>

          <p>
            {t("footer.tagline")}
            <br />
            <small>{t("footer.copyright")}</small>
          </p>
        </div>

        <div className="footer-col footer-links">
          <ul>
            <li>
              <i className="fas fa-circle-play" aria-hidden="true" />
              <Link to="/video">{t("footer.explanationVideo")}</Link>
            </li>
            <li>
              <i className="fas fa-circle-question" aria-hidden="true" />
              <Link to="/help">{t("footer.help")}</Link>
            </li>
            <li>
              <i className="fas fa-envelope" aria-hidden="true" />
              <Link to="/contact">{t("topbar.contact")}</Link>
            </li>
          </ul>
        </div>

        <div className="footer-col footer-links">
          <ul>
            <li>
              <i className="fas fa-circle-info" aria-hidden="true" />
              <Link to="/impressum">{t("bottomline.impressum")}</Link>
            </li>
            <li>
              <i className="fas fa-scale-balanced" aria-hidden="true" />
              <Link to="/agb">{t("bottomline.agb")}</Link>
            </li>
            <li>
              <i className="fas fa-shield-halved" aria-hidden="true" />
              <Link to="/datenschutz">{t("bottomline.privacy")}</Link>
            </li>
            <li>
              <i className="fas fa-cookie-bite" aria-hidden="true" />
              <Link to="/cookies-policy">{t("bottomline.cookies")}</Link>
            </li>
            <li>
              <i className="fas fa-sliders" aria-hidden="true" />
              <button
                type="button"
                className="cookie-settings-button"
                onClick={openPreferences}
              >
                {t("consent.settings")}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
